/**
 * AdminJuegosLotowheelVirtualesView — Web Component (Light DOM)
 *
 * Vista de gestión de Juegos del panel de administración.
 * Contiene:
 *   - Tabs dinámicos de tipos de juego (cargados desde /api/game-types).
 *   - Tab LotoWheel: subtabs Públicos (configs) y Virtuales (sorteos en RAM).
 *   - Tab Pozos Comunes: gestión de pozos suprajuego.
 * Migrado desde index.html (sección Juegos).
 */
import { t } from '../../services/i18n-admin.js';
import { icon } from '../../utils/icon.js';

export class AdminJuegosLotowheelVirtualesView extends HTMLElement {
    connectedCallback() {
        this.innerHTML = `
            <section class="view" id="view-juegos">
                <div class="section-header">
                    <h3 class="section-title">${t('Juegos')}</h3>
                    <!-- Tabs dinámicos: renderizados desde /api/game-types por App.loadGameTypes() -->
                    <div class="view-tabs" id="gameTypeTabs">
                        <span class="tab-loading">${t('Cargando juegos...')}</span>
                    </div>
                </div>

                <!-- TAB: LotoWheel -->
                <div class="tab-content active" id="tab-juegos-lotowheel">
                    <!-- Subtabs: Públicos / Virtuales -->
                    <div class="subtabs" style="margin-bottom: 16px; display: flex; gap: 8px">
                        <button
                            class="tab-btn small active"
                            data-subtab="publicos"
                            data-action="app:switchLotowheelSubtab"
                            data-param="publicos"
                        >
                            ${t('Publicos')}
                        </button>
                        <button
                            class="tab-btn small"
                            data-subtab="virtuales"
                            data-action="app:switchLotowheelSubtab"
                            data-param="virtuales"
                        >
                            ${t('Virtuales')}
                        </button>
                    </div>

                    <!-- SUBTAB: Públicos -->
                    <div class="subtab-content active" id="subtab-publicos">
                        <div class="tab-actions">
                            <button class="btn btn-primary" data-action="lotowheel:openConfigModal">
                                ${icon('plus')}
                                <span>${t('Nuevo Sorteo LotoWheel')}</span>
                            </button>
                        </div>
                        <div class="cards-grid" id="lotowheelConfigsGrid"></div>
                    </div>

                    <!-- SUBTAB: Virtuales -->
                    <div class="subtab-content" id="subtab-virtuales" style="display: none">
                        <div class="kpi-grid">
                            <div class="kpi-card">
                                <div class="kpi-label">${t('Activos en RAM')}</div>
                                <div class="kpi-value green" id="vdActiveCount"><span class="skeleton-bar" style="display:inline-block;width:40px;height:20px;"></span></div>
                            </div>
                            <div class="kpi-card">
                                <div class="kpi-label">${t('Memoria')}</div>
                                <div class="kpi-value blue" id="vdMemory"><span class="skeleton-bar" style="display:inline-block;width:50px;height:20px;"></span></div>
                            </div>
                            <div class="kpi-card">
                                <div class="kpi-label">${t('Total Creados')}</div>
                                <div class="kpi-value" id="vdTotalCreated"><span class="skeleton-bar" style="display:inline-block;width:40px;height:20px;"></span></div>
                            </div>
                        </div>

                        <div class="tab-actions" style="margin-top: 16px">
                            <button class="btn btn-secondary" data-action="lotowheel:recoverVirtualDraws">
                                ${icon('activity')}
                                <span>${t('Recuperar Huérfanos')}</span>
                            </button>
                            <button class="btn btn-primary" data-action="lotowheel:createVirtualDrawPrompt">
                                ${icon('plus')}
                                <span>${t('Crear Sorteo Virtual')}</span>
                            </button>
                        </div>

                        <div class="table-container" style="margin-top: 16px">
                            <div class="table-header">
                                <h3>${t('Sorteos Virtuales Activos')}</h3>
                            </div>
                            <table>
                                <thead>
                                    <tr>
                                        <th>${t('ID')}</th>
                                        <th>${t('Propietario')}</th>
                                        <th>${t('Sorteo #')}</th>
                                        <th>${t('Intervalo')}</th>
                                        <th>${t('Estado')}</th>
                                        <th>${t('Acciones')}</th>
                                    </tr>
                                </thead>
                                <tbody id="virtualDrawsTable">
                                    <tr>
                                        <td colspan="6" style="text-align: center; padding: 20px">
                                            ${t('Cargando...')}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <!-- TAB: Digi 12 (pestaña generada desde game_types; este es su contenido) -->
                <div class="tab-content" id="tab-juegos-digi12" style="display: none">
                    <div class="tab-actions">
                        <button class="btn btn-primary" data-action="digi12:openModal">
                            ${icon('plus')}
                            <span>${t('Nuevo producto Digi 12')}</span>
                        </button>
                    </div>
                    <div class="games-grid" id="digi12ProductosGrid"></div>
                </div>

                <!-- TAB: Pozos Comunes (suprajuego) -->
                <div class="tab-content" id="tab-juegos-pozos-comunes" style="display: none">
                    <div class="tab-actions">
                        <button class="btn btn-primary" data-action="pozos:openCreateModal">
                            ${icon('plus')}
                            <span>${t('Nuevo Pozo')}</span>
                        </button>
                    </div>
                    <div id="pozosGrid"></div>
                </div>
            </section>
        `;
    }
}

customElements.define('admin-juegos-lotowheel-virtuales-view', AdminJuegosLotowheelVirtualesView);
